import * as Sentry from '@sentry/react';
import {getSite} from '../selectors';

const handleEpaymentError = (errorResponse) => {
	let errors = [];
	let unexpected = true;

	/* 
			{"status":false,
			"messages":[{"name":"Error","param":"contact","location":"body/order/receivers/0","message":"Invalid Receiver's Contact Number length!","value":"0905072272057"}],
			"data":{},"code":1}
		*/

	const data = errorResponse.data ?? {errors: [], message: ''};

	if (data.message === 'Phone number Does Not Exist in Local Operators') {
		errors.push('رقم الهاتف غير صحيح او لا يدعم خدمة الدفع الالكتروني');
		unexpected = false;
	} else if (data.message === 'The given data was invalid.') {
		if (data.errors?.phone) {
			errors.push('يرجى ادخال رقم الهاتف');
			unexpected = false;
		}
	}

	if (unexpected) {
		Sentry.captureMessage('TLYNC Unexpected Error response', {
			level: 'warning',
			extra: {
				response: JSON.stringify(errorResponse),
				tenant_id: getSite()?.id,
				tenant_name: getSite()?.site_name,
			},
			context: {
				url: window.location.href,
			},
		});
	}

	return errors;
};

export default handleEpaymentError;
